import { createAsyncThunk } from '@reduxjs/toolkit';
import { DiscussionEmailAddress } from '../../models/discussion-email-address';

export const fetchDiscussionEmailAddress = createAsyncThunk(
    'clubhouse/fetchDiscussionEmailAddress',
    async (
        params: { clubhouseId: number; discussionId: number },
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get(
            `api/clubhouses/${params.clubhouseId}/discussions/${params.discussionId}/email-address`
        );
        const data = response.data as DiscussionEmailAddress;
        return {
            discussionId: params.discussionId,
            emailAddress: data.emailAddress,
            displayName: data.displayName,
            namedEmailAddress: data.namedEmailAddress,
        };
    }
);
